"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Star = exports["default"] = /*#__PURE__*/function (_Container) {
  function Star(manager) {
    var _this;
    _classCallCheck(this, Star);
    _this = _callSuper(this, Star);
    // These are the white specs that (seemingly) move towards the screen, you can force them to be idle by
    // by changing the variable to true
    _defineProperty(_this, "manager", void 0);
    _defineProperty(_this, "sprite", void 0);
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "force", void 0);
    _defineProperty(_this, "minScaleY", void 0);
    _defineProperty(_this, "forceIdle", void 0);
    _defineProperty(_this, "isIdle", void 0);
    _defineProperty(_this, "starterPos", void 0);
    _this.manager = manager;
    return _this;
  }
  _inherits(Star, _Container);
  return _createClass(Star, [{
    key: "build",
    value: function build() {
      var sprite = new _pixi.Sprite(_pixi.Texture.from("star_blitz.png"));
      var spriteFx = new _pixi.Sprite(_pixi.Texture.from("p3_blitz.png"));
      sprite.addChild(spriteFx);
      spriteFx.anchor.set(0.5);
      spriteFx.scale.set(0.5);
      sprite.fx = spriteFx;
      if (Math.random() < 0.8) sprite.fx.visible = false;
      sprite.alpha = 0.75;
      this.addChild(sprite);
      sprite.anchor.x = 0.5;
      sprite.anchor.y = 1;
      sprite.scale.set(0.02);
      sprite.tint = this.manager.color;
      this.sprite = sprite;
    }
  }, {
    key: "reset",
    value: function reset(color) {
      var randomise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      randomise ? this.color = Math.random() * 16777215 : this.color = color;
      this.force = Math.random() * this.force;
      this.sprite.tint = this.color;
      this.sprite.scale.y = this.minScaleY;
    }
  }, {
    key: "update",
    value: function update() {
      this.force = this.manager.globalForce + this.minScaleY * 2;
      if (this.forceIdle) {
        this.force = 0.1;
        this.isIdle = true;
      }
      this.x += Math.cos(this.angle) * this.force;
      this.y += Math.sin(this.angle) * this.force;
      this.alpha = this.lerp(1, this.alpha, 0.5);

      // WHY?????
      //  const dist = Math.hypot(this.starterPos.x - this.x, this.starterPos.y - this.y);

      this.sprite.rotation = this.angle + Math.PI / 2;
      this.sprite.scale.y = this.minScaleY * this.force * 6;
      this.sprite.scale.y = Math.max(this.sprite.scale.y, this.minScaleY);
      this.force = Math.max(this.force, 0.02);
      this.sprite.scale.x = this.minScaleY + this.minScaleY * this.force;
      if (this.isIdle) {
        this.sprite.alpha = this.minScaleY * 10;
      } else {
        this.sprite.alpha = 0.75;
        this.sprite.fx.visible = false;
        this.sprite.scale.x = this.minScaleY + this.minScaleY * this.force * this.manager.starWidth;
      }
    }
  }, {
    key: "lerp",
    value: function lerp(v0, v1, t) {
      return v0 * (1 - t) + v1 * t;
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=Star.js.map